import { createEvent, createStore, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  CreateDeposit,
  Exchanger,
  ExchangerResponse,
  GatewayRequest,
  GatewayResponse,
} from './types'
import { Gateway } from '../../../gateway/list/types'
import { RequestError } from '../../../../shared/errorResponse'

export const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string | number
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const mapSearchText = (searchText: {
  [key: string]: string | number
}) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]]
    }),
  )
}

export const gatewaysListMounted = createEvent<GatewayRequest>()

export const createDepositMounted = createEvent<CreateDeposit>()

export const exchangerMounted = createEvent<{ clientId: string }>()

export const closeModal = createEvent()

export const resetExchangersError = createEvent()

export const getGateways = fx<GatewayRequest, GatewayResponse>({
  method: 'GET',
  url: `/gateway`,
})

export const getExchanger = fx<void, ExchangerResponse>({
  method: 'GET',
  url: '/exchanger/',
})

export const createDeposit = fx<CreateDeposit, void>({
  method: 'POST',
  url: `/transaction_request/deposit/manual`,
})

export const $gateways = restore<Gateway[]>(
  getGateways.doneData.map((a) => a.body.items),
  [],
)

export const $exchangers = restore<Exchanger[]>(
  getExchanger.doneData.map((a) => a.body.items),
  [],
)

export const $exchangersError = createStore<string | null>(null)
  .on(getExchanger.failData, (_, error) => {
    return error.body.message || 'Произошла ошибка при загрузке accounts'
  })
  .reset([getExchanger.done, resetExchangersError])

export const $isSuccessCreate = restore(
  createDeposit.doneData.map(() => true),
  false,
).reset(closeModal)

export const $createError = createStore<RequestError | null>(null)
  .on(createDeposit.failData, (_, error) => {
    return {
      message: error.body.message || 'Произошла ошибка при загрузке accounts',
      code: error.body.code,
    }
  })
  .reset([createDeposit.done, closeModal])

sample({
  // @ts-ignore
  clock: exchangerMounted,
  fn: ({ clientId }) => {
    return {
      url: `/exchanger/?where={"ownerId":"${clientId}"}`,
    }
  },
  target: getExchanger,
})

sample({
  clock: createDepositMounted,
  fn: (data) => {
    return {
      url: `/transaction_request/deposit/manual`,
      body: {
        ...data,
      },
    }
  },
  target: createDeposit,
})

sample({
  // @ts-ignore
  clock: gatewaysListMounted,
  fn: ({ searchText }) => {
    let query = {}

    let newObj = {}

    if (searchText && !isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getGateways,
})
